enum SupportedLocale {
  DE_DE = 'de_DE',
  IT_IT = 'it_IT',
  DE_IT = 'de_IT',
  EN_GB = 'en_GB',
  PL_PL = 'pl_PL',
  ES_ES = 'es_ES',
  NL_NL = 'nl_NL',
  DE_AT = 'de_AT',
  FR_FR = 'fr_FR',
  HU_HU = 'hu_HU',
  FR_BE = 'fr_BE',
  NL_BE = 'nl_BE',
  DE_CH = 'de_CH',
  FR_CH = 'fr_CH',
  IT_CH = 'it_CH',
  DA_DK = 'da_DK',
  SV_SE = 'sv_SE',
  FI_FI = 'fi_FI'
}

export default SupportedLocale;
